import React from "react";

const Footer: React.FC = () => {
  return (
    <footer
      className="w-full border-t border-gray-300 bg-gray-50 text-black relative"
      style={{ borderTopColor: "#cacaca" }}
    >
      <div className="max-w-screen-xl mx-auto px-4 flex flex-col md:flex-row justify-center md:justify-between items-center py-4 space-y-4 md:space-y-0 text-center md:text-left">
        {/* Logo and Copyright */}
        <div className="flex flex-col items-center md:flex-row md:items-center md:justify-start space-y-2 md:space-y-0">
          <a
            href="https://www.sustamize.com" // Replace with your desired URL
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/images/no_results.svg"
              alt="sustamize Logo"
              className="w-12 h-12 mb-2 md:mb-0 md:mr-4"
            />
          </a>
          <p className="text-sm">© sustamize GmbH 2026. All rights reserved.</p>
        </div>
        {/* Links */}
        <div className="flex flex-col md:flex-row md:space-x-6 items-center md:justify-end text-sm space-y-2 md:space-y-0">
          <a
            href="https://sustamizer.com/login"
            className="inline-flex items-center hover:underline"
          >
            sustamizer Login
            <img
              src="/images/database_ref.svg"
              alt="Database Login"
              className="w-3 h-3 ml-1"
            />
          </a>
          <a
            href="https://www.sustamize.com/contact"
            className="hover:underline"
          >
            Contact Us
          </a>
          <a
            href="https://share-eu1.hsforms.com/14M56owquRuCDe8Atb9JfoAfaf1j"
            className="hover:underline"
          >
            Newsletter
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
